"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestEmployeesV2 = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_1 = __importDefault(require("../util/error"));
const fetch_1 = __importDefault(require("../util/fetch"));
const query_1 = __importDefault(require("./query"));
const EMPLOYEES_QUERY = (0, graphql_tag_1.default) `query EmployeesQuery (
  $id: ID!
  $locality: ID
  $userIds: [ID!]
) {
  workspace (
    id: $id
  ) {
    members (
      locality: $locality
      userIds: $userIds
    ) ${query_1.default.MEMBER}
  }
}`;
const requestEmployeesV2 = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(EMPLOYEES_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace.members;
};
exports.requestEmployeesV2 = requestEmployeesV2;
async function requestEmployees(variables, token) {
    const response = await (0, fetch_1.default)({
        variables,
        query: EMPLOYEES_QUERY,
        // @ts-expect-error
        token,
    });
    if (!response)
        return error_1.default.noResponse();
    // @ts-expect-error
    const { errors, data } = response;
    if (errors) {
        const error = error_1.default.apiError('employees', errors);
        return { ...data?.workspace, ...error }; // in case of an error, we still return the data, but add the 'error' prop and we deal with that in /ac/load-employees.js
    }
    return data.workspace;
}
exports.default = requestEmployees;
